module.exports = __webpack_public_path__ + "img/syariah.c5d1da89.png";